<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select class="selScale" v-model="filter.dev_type">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="插座" value="power_charge_cz"> </el-option>
          <el-option label="充电桩" value="power_charge_pile"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
      <el-form-item label="设备号">
        <el-input placeholder="请输入设备号" v-model="tableForm.deviceid" clearable></el-input>
      </el-form-item>
    </el-form>

    <el-card class="box-card" style="height: 100%">
      <el-table header-cell-class-name="table-header-cell" :data="tableData" height="66vh" v-loading="loading">
        <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
        <el-table-column label="订单编号" prop="ordernum" width="220" align="center"> </el-table-column>
        <el-table-column label="订单金额" prop="omoney" align="center" width="180"></el-table-column>
        <el-table-column label="设备编号" prop="deviceid" align="center" width="240"></el-table-column>
        <el-table-column label="状态" prop="status_name" align="center" width="80">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status == 1">在线</el-tag>
            <el-tag type="info" v-else>离线</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="原因" prop="reason" width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="下单时间" prop="order_time" width="190" align="center"></el-table-column>
        <el-table-column label="检测时间" prop="create_time" width="190" align="center"></el-table-column>
        <el-table-column :label="$t('publics.operation')" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 设备状态详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" title="详情" width="1300px" :close-on-click-modal="false" class="detail-dialog lower_formitem_box">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm" style="padding: 0px 30px">
            <!-- 1. 档案信息（triplet） -->
            <h3>档案信息</h3>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="资产码" prop="assetsCode">
                  <el-input v-model="detailForm.triplet.assetsCode" readonly disabled />
                </el-form-item>
                <el-form-item label="出厂编码" prop="FactoryCode">
                  <el-input v-model="detailForm.triplet.FactoryCode" readonly disabled />
                </el-form-item>

                <el-form-item label="公钥" prop="PublickKey">
                  <el-input v-model="detailForm.triplet.PublickKey" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="私钥" prop="SecrtKey">
                  <el-input v-model="detailForm.triplet.SecrtKey" readonly disabled />
                </el-form-item>
                <el-form-item label="注册码" prop="RegCode">
                  <el-input v-model="detailForm.triplet.RegCode" readonly disabled />
                </el-form-item>
                <el-form-item label="类型名称" prop="TypeName">
                  <el-input v-model="detailForm.triplet.TypeName" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态" prop="State">
                  <el-input v-model="detailForm.triplet.State" readonly disabled />
                </el-form-item>
                <el-form-item label="创建时间" prop="CreateTime">
                  <el-input v-model="detailForm.triplet.CreateTime" readonly disabled />
                </el-form-item>
                <el-form-item label="" prop="triplet_id">
                  <el-button type="primary" v-permision_tjtf="'send_query_sim'" @click="onSendQuerySim(detailForm)"> 查询sim</el-button>
                  <!-- <el-button type="primary" v-permision_tjtf="'call_offline_order'" v-if="detailForm.status == 1" @click="onCallOfflineOrder(detailForm)">招离线订单</el-button> -->
                  <el-button type="primary" v-if="detailForm.dev_type == 1" @click="onTimeSync(detailForm)">YCK对时</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { GetErrorOrderPageList } from "@/api/error_order"

import { Send_DevRestart, Send_QuerySim, Send_TimeSync } from "@/api/dev_send_order"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: {},
  data() {
    return {
      tableData: [],
      visible: {
        curve: false,
        ordercurve: false
      },
      filter: {
        assets_code: "",
        dev_type: ""
      },
      loading: false,
      isUpdate: true,
      gid: "",
      detailVisible: false,
      modelParams: {},
      detailForm: {
        // 基本档案信息
        ID: "",
        triplet: {},
        firmware_evt: {},
        acDeRealIty: {},
        verinfo_evt: {},
        dev_inform_evt: {},
        status: 0,
        re_dev_type: "",
        dev_type: 0
      },
      tableForm: {
        deviceid: ""
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },
    // 打开详情弹窗
    async onDetail(row) {},

    getData() {
      this.loading = true
      GetErrorOrderPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code || null,
        dev_type: this.filter.dev_type || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.my-pagination {
  margin-top: 20px;
  text-align: right;
}
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 去除详情对话框的内外边距 */
.detail-dialog ::v-deep .el-dialog {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* 确保表格容器没有额外间距 */
.my-pagination {
  margin-top: 20px;
  text-align: right;
}
.zanwu {
  line-height: 50px;
  text-align: center;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
</style>
